import { api } from "@/lib/apiClient";

type LoginPayload = {
  email: string;
  password: string;
  remember?: boolean;
};

export type AuthUser = {
  id: number;
  name: string;
  email: string;
  role?: string;
  email_verified_at: string | null;
  created_at: string;
  updated_at: string;
};

export const getCsrfCookie = async () => {
  await api.get("/sanctum/csrf-cookie");
};

export const login = async ({ email, password, remember = false }: LoginPayload) => {
  await getCsrfCookie();
  const response = await api.post("/api/v1/web/login", {
    email,
    password,
    remember,
  });
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get("/api/v1/user");
  return response.data;
};

export const changePassword = async (payload: {
  current_password: string;
  password: string;
  password_confirmation: string;
}) => {
  const response = await api.post("/api/v1/user/password", payload);
  return response.data;
};

export const updateProfile = async (payload: {
  name: string;
  phone?: string | null;
  avatar?: File | null;
  removeAvatar?: boolean;
}) => {
  if (payload.avatar instanceof File) {
    const form = new FormData();
    form.append("name", payload.name);
    form.append("phone", payload.phone ?? "");
    form.append("avatar", payload.avatar);
    // POST so PHP parses multipart body (PATCH + multipart often drops fields like `name`).
    const response = await api.post("/api/v1/user", form);
    return response.data;
  }
  const body: Record<string, unknown> = {
    name: payload.name,
    phone: payload.phone ?? null,
  };
  if (payload.removeAvatar) {
    body.remove_avatar = true;
  }
  const response = await api.patch("/api/v1/user", body);
  return response.data;
};

export const logout = async () => {
  await api.post("/api/v1/web/logout");
};
